import { useState } from 'react';
import { SelectSingleEventHandler } from 'react-day-picker';

import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';
import { Calendar } from './ui/calendar';

export function DatePicker({
  selected,
  onSelect,
  children,
}: {
  selected: Date | undefined;
  onSelect: (date: Date | undefined) => void;
  children: React.ReactNode;
}) {
  const [isPopoverOpen, setIsPopoverOpen] = useState<boolean>(false);

  const handleOnSelect: SelectSingleEventHandler = (date) => {
    onSelect?.(date);
    setIsPopoverOpen(false);
  };

  return (
    <Popover open={isPopoverOpen} onOpenChange={setIsPopoverOpen}>
      <PopoverTrigger asChild>{children}</PopoverTrigger>
      <PopoverContent className='w-auto p-0' align='start'>
        <Calendar
          mode='single'
          selected={selected}
          onSelect={handleOnSelect}
          initialFocus
          captionLayout='dropdown-buttons'
          fromYear={1950}
          toYear={new Date().getFullYear()}
          disabled={{ after: new Date() }}
        />
      </PopoverContent>
    </Popover>
  );
}
